import { alpha } from '@mui/material';
import { blue, green, orange } from '@mui/material/colors';
import headerAdHocSmall from '../assets/header-adhoc-small.svg';
import headerCloudSmall from '../assets/header-cloud-small.svg';
import headerNeutralSmall from '../assets/header-neutral-small.svg';
import headerSiteSmall from '../assets/header-site-small.svg';
import ksimClassroomCloud from '../assets/ksim-classroom-cloud.png';
import ksimClassroomSite from '../assets/ksim-classroom-site.png';
import ksimSelfStudyCloud from '../assets/ksim-self-study-cloud.png';
import ksimSelfStudySite from '../assets/ksim-self-study-site.png';
import { ExerciseType, SimulatorType } from '../types';

export const getKSim = (exerciseType: ExerciseType, simulatorType?: SimulatorType) => {
  const simType = simulatorType ?? (exerciseType ? SimulatorType.Site : SimulatorType.Cloud);

  return {
    Cloud: { [ExerciseType.Classroom]: ksimClassroomCloud, [ExerciseType.SelfStudy]: ksimSelfStudyCloud },
    Site: { [ExerciseType.Classroom]: ksimClassroomSite, [ExerciseType.SelfStudy]: ksimSelfStudySite },
  }[simType][exerciseType];
};

export const getSmallHeaderBg = (simulatorType?: SimulatorType, adHoc?: boolean) =>
  adHoc
    ? headerAdHocSmall
    : simulatorType
    ? {
        [SimulatorType.Cloud]: headerCloudSmall,
        [SimulatorType.Site]: headerSiteSmall,
      }[simulatorType] ?? headerNeutralSmall
    : headerNeutralSmall;

export const getBgColor = (simulatorType?: SimulatorType, adHoc?: boolean) =>
  adHoc
    ? orange[100]
    : simulatorType
    ? {
        [SimulatorType.Cloud]: alpha('#5A6EDD', 0.3),
        [SimulatorType.Site]: green[100],
      }[simulatorType] ?? blue[100]
    : blue[100];
